import TableBlockIcon from "../../../images/default_table_block_new_icon.svg";
import TabsBlockIcon from "../../../images/default_tabs_block_new_icon.svg";
// import "./customLinkBlock.scss";

export const customTableBlock = (editor) => {
    editor.Blocks.add("Table", {
        category: "extra",
        label: "Table",
    
        media: `<img src="${TableBlockIcon}" class="table-block" title="Table" alt="table" draggable="false"/>`,
        id: "table",
        // media: `<img src="${TableIcon}" alt="table" />`,
        content: { type: "table" },
        activate: false,
    });

      editor.Blocks.add("Tabs", {
        category: "extra",
        label: "Tabs",
        media: `<img src="${TabsBlockIcon}" class="tabs-block" alt="tab" draggable="true"/>`,
        id: "tabs",
        // media: `<img src="${TabIcon}" alt="tabs" />`,
        content: {
          type: "tabs",
          unstylable: ["transform", "transition", "perspective"],
        },
        activate: true,
      });

//   editor.Components.addType("paragraph", {
//     extend: "paragraph",
//     model: {
//       defaults: {
//         editable: false,
//         droppable: `[data-gjs-type="form"],
//        [data-gjs-type="default"],
//        [data-gjs-type="Div"],
//        [data-gjs-type="text"],
//        [data-gjs-type="image"],
//        [data-gjs-type="table"],
//        [data-gjs-type="tabs"],
//        [data-gjs-type="textarea"],
//        [data-gjs-type="video"],
//        [data-gjs-type="hr"],
//        [data-gjs-type="input"],
//        [data-gjs-type="select"],
//        [data-gjs-type="button"],
//        [data-gjs-type="label"],
//        [data-gjs-type="checkbox"],
//        [data-gjs-type="radio"]
//        `,

//         style: {
//           display: "inline-block",
//           padding: "5px",
//           "min-height": "50px",
//           "min-width": "50px",
//         },
//         attributes: { href: "http://google.com" },
//       },
//     },
//   });
};
